<template>
    <kgr-form-scaffold
        :pending="pending"
        :save-button-disabled="!newFeeValid"
        with-back-button
        with-primary-buttons
        @primaryBtnClicked="createFee"
        @backBtnClicked="redirectToOverview"
    >
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Neuen Beitrag anlegen') }}
        </h3>
        <kgr-club-fee-form
            :club-id="clubId"
            :club-fee-edit="newFee"
            :error="error"
            @update="updateFee($event)"
        />
    </kgr-form-scaffold>
</template>

<script>
import AccountingClubFee from '../../../js/dto/AccountingClubFee.js';
import ClubFeeForm from '../../../components/club/accounting/ClubFeeForm.vue';
import ClubFeeRepository from '../../../js/repository/ClubFeeRepository.js';
import Error from '../../../js/model/Error.js';
import FormScaffold from '../../../components/common/form/FormScaffold.vue';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-club-fee-form': ClubFeeForm,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            newFee: null,
        }
    },
    computed: {
        newFeeValid() {
            return this.newFee.category !== null && this.newFee.name !== '';
        },
    },
    created() {
        this.initNew();
    },
    methods: {
        initNew() {
            this.newFee = new AccountingClubFee();
            this.newFee.basePrice = {
                amount: 10,
                amountCent: 0,
                netOrGross: 'gross',
                currency: 'EUR',
                vat: 0,
                type: {value: 'oneTime', text: this.$t('einmalig')},
            };
        },
        updateFee(clubFee) {
            this.newFee = clubFee;
        },
        redirectToOverview() {
            window.location = `/backend/clubs/${this.clubId}/accounting/fee-management`;
        },
        createFee() {
            this.loading = true;
            ClubFeeRepository.create(this.clubId, this.newFee.serialize())
                .then(() => this.redirectToOverview())
                .catch(() => this.$notify.error('saveChanges.error'))
                .finally(() => this.loading = false);

            this.initNew();
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
